$.extend tower,
  initPasswordConfirmRequiredForm: (options) ->
    formSelector = options.formSelector
    submitButtonSelector = options.submitButtonSelector || '.btn-submit'
    dialogTemplate = options.dialogTemplate
    confirmFormSelector = options.confirmFormSelector
    confirmFormSubmitButtonSelector = options.confirmFormSubmitButtonSelector || '.btn-submit'
    passwordFieldSelector = options.passwordFieldSelector || '[name="password_confirmation"]'

    $(formSelector)
      .on 'click', submitButtonSelector, (e) ->
        dialog = simple.dialog
                  content: dialogTemplate
                  buttons: null

        $(confirmFormSelector)
          .on 'click', confirmFormSubmitButtonSelector, (e) ->
            $currentPage = $('.page-inner:last')
            $form = $currentPage.find(formSelector)
            $confirmForm = $(e.currentTarget).closest(confirmFormSelector)
            $confirmFormPasswordField = $confirmForm.find(passwordFieldSelector)
            password = $confirmFormPasswordField.val()

            if password
              $form.find(passwordFieldSelector).val(password)
              $form.trigger('submit')
            else
              passwordFieldName = $confirmFormPasswordField.attr('name')
              $confirmForm.trigger('validateFailed', {"#{passwordFieldName}": 'empty'})
          .on 'validateFailed', (e, params) ->
            $confirmForm = $(e.currentTarget)
            for key, value of params
              $confirmForm.find("[name='#{key}']").trigger("#{value}.validate")
          .on 'empty.validate invalid.validate', 'input[name]', (e) ->
            eventType = e.type
            $formField = $(e.currentTarget)
            $formItem = $formField.closest('.form-item')
            $formItem
              .addClass(eventType)
              .find('p.error')
                .remove()
              .end()
                .append("<p class='error'>#{$formField.data("#{eventType}-tip")}</p>")
          .on 'focusin', 'input[name]', (e) ->
            $(e.currentTarget).closest('.form-item').removeClass('empty invalid')
          .on 'click', '.btn-x', (e) ->
            dialog.remove()
